import { ApiNameType, ResourceKey, StoreApiKeyType, StoreNameType } from './models/subscriptions';

const KEY_SEPARATOR = '__';

export const generateApiStoreKey = (storeName: StoreNameType, apiName: ApiNameType, resourceKey?: ResourceKey): StoreApiKeyType => {
  const keys = [storeName, apiName];
  if (resourceKey) {
    keys.push(resourceKey.toString());
  }
  return keys.join(KEY_SEPARATOR);
};

export const getResourceKey = (arg?: Record<string, number>, isCollection?: boolean) => {
  if (!isCollection) {
    return Object.keys(arg ?? {})[0] ?? '';
  }

  return arg ? Object.keys(arg) : [];
};
